import { render, staticRenderFns } from "./StartExam.vue?vue&type=template&id=65d123b6&scoped=true&"
import script from "./StartExam.vue?vue&type=script&lang=js&"
export * from "./StartExam.vue?vue&type=script&lang=js&"
import style0 from "./StartExam.vue?vue&type=style&index=0&id=65d123b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d123b6",
  null
  
)

export default component.exports